  // Cookie utilities
  
  declare global {
    interface Window {
        dataLayer:any;
    }
}

  const setCookie = (name:string, value:string, expirationDate:Date) => {
    const expires = `expires=${expirationDate.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  };

  const getCookie = (name:string) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length);
      }
    }
    return null;
  };
  

  const deleteCookie = (name:string) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  };

  // Get random variant (A or B)
  const getRandomVariant = () => {
    return Math.random() < 0.5 ? 'a' : 'b';
  };

  // Initialize or read A/B test
  export const initializeTest = (testName:string, shouldRunTest = true, setVariant:any) => {
    console.log('initializeTest ------- ');
    if (!shouldRunTest) {
      setVariant('');
      return;
    }

    const cookieName = '_site-exp-cookie';
    const existingCookie = getCookie(cookieName);

    // onetrustloaded is an event provided by onetrust that we can listen to to activate our cookie check if we need to
    // window.addEventListener('onetrustloaded', function() {
        // OneTrust is loaded and ready, you can now check consent or fire tags
        console.log(' -------> ');

        // Check if cookie exists and matches current test
      if (existingCookie && existingCookie.startsWith(testName)) {
        // if we wanted to start new test
        // startNewTest()
        const variantLetter = existingCookie.split('-variant-')[1];

        window.dataLayer.push({ 
          'event': 'exp-data-push', 
          'exp_variant': `csbb-uf-${testName}-cta-${variantLetter}`
        }); 

        console.log('cookie exists reading variable ', variantLetter);
        setVariant(variantLetter);
      } else {
        // Create new test assignment
        const variantLetter = getRandomVariant();
        const cookieValue = `${testName}-variant-${variantLetter}`;
        const expirationDate = new Date('2026-02-16T23:59:59');

        window.dataLayer.push({ 
          'event': 'exp-data-push', 
          'exp_variant': `csbb-uf-test-3-cta-${variantLetter}`
        }); 

        console.log('cookie does not exist - randomVariable ', variantLetter);

        setCookie(cookieName, cookieValue, expirationDate);
        setVariant(variantLetter);

      }
    // });

    
    

    
  };

  // Reset test and start a new one
  export const startNewTest = (newTestName:any, shouldRunTest = true) => {
    if (!shouldRunTest) {
    //   setVariant(null);
      return;
    }

    const cookieName = 'ab-test';
    deleteCookie(cookieName);
    
    const variantLetter = getRandomVariant();
    const cookieValue = `${newTestName}-variant-${variantLetter}`;
    const expirationDate = new Date('2026-02-16T23:59:59');
    
    setCookie(cookieName, cookieValue, expirationDate);
    // setVariant(variantLetter === 'a');
    // setCurrentTest(newTestName);
  };
